import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Home from './pages/Home/Home';
import HowItWorks from './pages/How it Works/HowItWorks';
import Contact from './pages/Contact/Contact';
import InTheNews from './pages/News/News';
import Roadmap from './pages/Roadmap/Roadmap';
import About from './pages/About/About';
import BetaTesting from './pages/BetaTesting/BetaTesting';
import Privacy from './pages/Privacy/Privacy';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/news"element={<InTheNews />} />
          <Route path="/roadmap"element={<Roadmap />} />
          <Route path="/about" element={<About />} />
          <Route path="/beta-testing" element={<BetaTesting />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;